import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/apiEnvelope';

function getPublicPagesBasePath() {
  return (
    process.env.REACT_APP_PUBLIC_CONTENT_PAGES_PATH || '/api/content/pages'
  ).replace(/\/$/, '');
}

/**
 * GET /api/content/pages/{slug}?language=en|ar|ku
 * @param {string} slug
 * @param {string} language
 */
export async function fetchPublicPage(slug, language = 'en') {
  const base = getPublicPagesBasePath();
  const response = await axiosClient.get(
    `${base}/${encodeURIComponent(slug)}`,
    {
      params: { language },
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    }
  );

  const body = response?.data;
  if (body != null && typeof body === 'object' && 'success' in body) {
    return unwrapApiResponse(response);
  }
  return body;
}
